<template>
  <el-menu class="left-menu" style="text-align:left;height: 100%;" router unique-opened :default-active="current">
    <MenuTree :list="list"></MenuTree>
  </el-menu>
</template>
<script>
import MenuTree from './menu-tree'

export default {
  name: 'left-menu',
  props: ['list'],
  components: { MenuTree },
  data () {
    return {}
  },
  async created () {
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {
    current () {
      return this.$route.path
    }
  },
  watch: {},
  methods: {}
}
</script>
<style>
  .left-menu .el-submenu .el-menu-item:hover {
    color: #4E45EE;
    background-color: #EDECFD;
  }

  .left-menu .el-submenu .el-menu-item {
    border-left: solid 3px #EDECFD;
    color: #666666;
  }

  .left-menu .el-submenu .el-menu-item.is-active {
    background-color: #EDECFD !important;
    color: #4E45EE;
    border-left: solid 3px #4E45EE;
  }
</style>
